import { type HttpOptions, createHttpLink } from '@apollo/client'

import { getAnvilUrl } from '@/lib/apollo/utils/getAnvilUrl'

const clientHttpLink = () => {
  const url = getAnvilUrl()

  const enhancedFetch: HttpOptions['fetch'] = async (url, init) => {
    return fetch(url, {
      ...init,
      headers: {
        ...init?.headers,
        Cookie: '',
        origin: process.env.NEXT_PUBLIC_WEBAPP_URL ?? '',
      },
    })
  }

  return createHttpLink({
    uri: url,
    credentials: 'include',
    fetch: enhancedFetch,
    headers: {
      'Apollo-Require-Preflight': 'true',
    },
  })
}

export default clientHttpLink
